<template>
  <div>
    <div class="w-full mx-auto">
      <div class="block lg:grid lg:grid-cols-4 lg:gap-1 infos">
        <div class="flex justify-between h-full w25">
          <div class="w-full ml-12 flex justify-between items-center">
            <div class="text-center">
              <div><img src="/static/images/device.png" class="area-info"/></div>
              <div class="mt3">设备总数</div>
              <div class="mt3 device-number" style="color: rgb(37, 99, 235)">{{ devices }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-between h-full w25">
          <div class="w-full ml-12 flex justify-between items-center">
            <div class="text-left" style="text-align: center">
              <div><img src="/static/images/online.jpg" class="area-info"/></div>
              <div class="mt3">在线总数</div>
              <div class="mt3 device-number" style="color: rgb(22, 163, 74)">{{ online }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-between h-full w25">
          <div class="w-full ml-12 flex justify-between items-center">
            <div class="text-left" style="text-align: center">
              <div><img src="/static/images/alarm.png" class="area-info"/></div>
              <div class="mt3">报警总数</div>
              <div class="mt3 device-number" style="color: rgb(220, 38, 38)">{{ alarm }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-between h-full w25" @click="goRepair">
          <div class="w-full ml-12 flex justify-between items-center">
            <div class="text-center" style="text-align: center">
              <div><img src="/static/images/device.png" class="area-info"/></div>
              <div class="mt3">即将维保</div>
              <div class="mt3 device-number" style="color: rgb(219, 39, 119)">{{ repair }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 面包屑导航 -->
    <div>
      <el-calendar v-model="currentDate"></el-calendar>
    </div>

  </div>
</template>

<script>
import {home} from '../../api/userMG'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      loading: false, //是显示加载
      userparm: [], //搜索权限
      listData: [], //用户数据
      devices: 0,
      online: 0,
      alarm: 0,
      repair: 0,
      currentDate: new Date()
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.InitHome()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    InitHome() {
      home().then(res => {
        let info = res.result
        this.devices = info.devices
        this.online = info.online
        this.alarm = info.alarm
        this.repair = info.repair
      })
    },
    showTime() {
      time.value = dayjs().format('HH:mm:ss')
      day.value = dayjs().format('YYYY年MM月DD日')
    },
    goRepair() {
      this.$router.push('/home/repair')
      //this.$router.go('/home/repair')
    }
  }
}
</script>

<style scoped>
.infos {
  display: flex;
  padding: 20px 0px;
}

.w25 {
  width: 20%;
  margin: 0 2.5%;
  padding: 20px 0px;
  text-align: center;
  border: 1px dashed grey;
  border-radius: 15px;
}

.mt3 {
  margin-top: 10px;
  font-size: 1.3rem;
  font-weight: bold;
}

.device-number {
  font-size: 2rem !important;
}

.area-info {
  width: 80px;
  height: 80px;
}

::v-deep .el-calendar-table .el-calendar-day {
  height: 2em;
  text-align: left;
}
</style>





// WEBPACK FOOTER //
// src/views/home/index.vue